import React from 'react';
import { PiArrowsClockwise, PiWarningCircle } from 'react-icons/pi';
import OpterraLogo from '../../../assets/images/BPC_Opterra_logo.png';
import SoilWaterTagLine from '../SoilWaterTagLine';
import SubFooter from '../SubFooter';
import ContactSupport from '../ContactSupport/ContactSupport';

interface ErrorPageProps {
  error: unknown;
}

const isChunkLoadError = (error: unknown): boolean => {
  if (!(error instanceof Error)) return false;
  return (
    error.message.includes('Loading chunk') ||
    error.message.includes('ChunkLoadError') ||
    error.name === 'ChunkLoadError'
  );
};

const ErrorPage: React.FC<ErrorPageProps> = ({ error }) => {
  const isChunk = isChunkLoadError(error);

  return (
    <div className="flex min-h-screen flex-col">
      <div className="px-2 py-1">
        <img src={OpterraLogo} alt="Opterra" className="w-56" />
      </div>
      <div className="mx-auto flex flex-1 flex-col px-5 sm:w-form-md">
        <div className="flex flex-1 flex-col items-center justify-center gap-6 text-center">
          {isChunk ? (
            <PiArrowsClockwise className="text-5xl text-success" />
          ) : (
            <PiWarningCircle className="text-5xl text-danger" />
          )}
          <h2 className="text-2xl font-semibold text-charcoal">
            {isChunk
              ? 'A new version of the app is available'
              : 'Something went wrong'}
          </h2>
          <p className="text-base text-secondary-dark">
            {isChunk
              ? 'Your app has been updated. Please refresh the page to load the latest version.'
              : 'An unexpected error occurred. Please try again.'}
          </p>
          {isChunk && (
            <button
              className="rounded-[var(--radius-button)] bg-success px-6 py-2 text-base font-medium text-white transition-colors hover:bg-success-dark"
              onClick={() => window.location.reload()}
            >
              Refresh page
            </button>
          )}
          <ContactSupport />
        </div>
        <SoilWaterTagLine />
      </div>
      <SubFooter />
    </div>
  );
};

export default ErrorPage;
